import "babel-polyfill";

import Vue from "vue";
import App from "./App.vue";
import Button from "element-ui/lib/button";
import ButtonGroup from "element-ui/lib/button-group";
import Carousel from "element-ui/lib/carousel";
import CarouselItem from "element-ui/lib/carousel-item";
import Checkbox from "element-ui/lib/checkbox";
import Col from "element-ui/lib/col";
import Collapse from "element-ui/lib/collapse";
import CollapseItem from "element-ui/lib/collapse-item";
import Container from "element-ui/lib/container";
import DatePicker from "element-ui/lib/date-picker";
import Dialog from "element-ui/lib/dialog";
import Footer from "element-ui/lib/footer";
import Form from "element-ui/lib/form";
import FormItem from "element-ui/lib/form-item";
import Input from "element-ui/lib/input";
import Option from "element-ui/lib/option";
import Row from "element-ui/lib/row";
import Select from "element-ui/lib/select";
import Table from "element-ui/lib/table";
import TableColumn from "element-ui/lib/table-column";
import TabPane from "element-ui/lib/tab-pane";
import Tabs from "element-ui/lib/tabs";
import Tooltip from "element-ui/lib/tooltip";
import Message from "element-ui/lib/message";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import router from "@/router";
import store from "@/store";
import axios from "axios";
import i18n from "./i18n";
import httpClient from "@/api/httpClient";
import { setupInterceptors } from "./utils/httpInterceptors";
import lang from "element-ui/lib/locale/lang/tr-TR";
import locale from "element-ui/lib/locale";
import moment from "moment";
import  uuid  from 'vue-uuid'; 
import Inputmask from 'inputmask';

Vue.directive('mask', {
    bind: function (el, binding) {
        Inputmask(binding.value).mask(el.getElementsByTagName('INPUT')[0]);
    }
})

//import JsonExcel from "vue-json-excel";

//sync(store, router);

//Vue.component("downloadExcel", JsonExcel);

Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.config.productionTip = false;
[
  Button,
  ButtonGroup,
  Carousel,
  CarouselItem,
  Checkbox,
  Col,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Dialog,
  Footer,
  Form,
  FormItem,
  Input,
  Option,
  Row,
  Select,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tooltip
].forEach((component) => {
  Vue.use(component);
});

Vue.prototype.$message = Message;
Vue.use(uuid);
locale.use(lang);

console.log("---UUID----");
// Sets the default url used by all of this axios instance's requests
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

var correlationId = window.sessionStorage.getItem("correlationId");
if(correlationId == null){
  correlationId =  Vue.prototype.$uuid.v4();
  window.sessionStorage.setItem("correlationId",correlationId);
}
httpClient.defaults.headers.common["X-CORR"] =  correlationId;


var token = window.sessionStorage.getItem("BearerToken");
console.log("mainjs");
console.log(token);
if (token != null) {
  httpClient.defaults.headers.common["Authorization"] =
    "Bearer " + window.sessionStorage.getItem("BearerToken");
}

httpClient.defaults.headers.common["Content-Type"] =
  "application/vnd.myapp.type+json";


new Vue({
  router,
  store,
  i18n,
  uuid,
  render: (h) => h(App),
  created() {
    setupInterceptors(store);
  },
}).$mount("#app");
